export default "__VITE_ASSET__143a95fb__"